import { render } from "./ClientesPorProvincia.vue?vue&type=template&id=ae5ddc8a&scoped=true"
import script from "./ClientesPorProvincia.vue?vue&type=script&lang=ts"
export * from "./ClientesPorProvincia.vue?vue&type=script&lang=ts"

import "./ClientesPorProvincia.vue?vue&type=style&index=0&id=ae5ddc8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae5ddc8a"

export default script